var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 470 470",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:url(#linear-gradient);stroke-width:14px;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{fill:url(#linear-gradient-4);stroke:url(#linear-gradient-5);}.cls-2,.cls-3{stroke-width:4px;}.cls-3{fill:url(#linear-gradient-2);stroke:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 235,
    x2: 470,
    y2: 235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bb4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2191e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007edb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 80,
    y1: 332.73,
    x2: 390,
    y2: 332.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 78,
    y1: 332.73,
    x2: 392,
    y2: 332.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 80,
    y1: 137.27,
    x2: 390,
    y2: 137.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 78,
    y1: 137.27,
    x2: 392,
    y2: 137.27,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_79"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7,
    y: 7,
    width: 456,
    height: 456,
    rx: 88.32,
    ry: 88.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m374.2,245.52H95.8c-8.72,0-15.8,7.07-15.8,15.8s7.07,15.8,15.8,15.8h123.4v84.23l-42.16-42.16c-14.35-14.71-37.01,8.12-22.39,22.3l77.18,77.09c1.64,1.74,4.38,1.83,6.12.19.07-.06.13-.13.19-.19l77.18-77.09c14.62-14.17-8.12-37.01-22.39-22.3l-42.16,42.16v-84.23h123.4c8.72,0,15.8-7.07,15.8-15.8s-7.07-15.8-15.8-15.8Zm0,22.57h-127.92c-2.49,0-4.51,2.02-4.51,4.51v99.3c0,1.82,1.11,3.46,2.8,4.15,1.68.65,3.58.26,4.87-.99l49.92-49.83c6.14-6.23,15.8,3.52,9.57,9.57l-73.93,74.3-73.93-73.93c-6.23-6.05,3.43-15.8,9.57-9.57l49.92,49.92c1.27,1.3,3.2,1.69,4.87.99,1.69-.69,2.79-2.33,2.8-4.15v-99.3c0-2.49-2.02-4.51-4.51-4.51h-127.92c-3.74,0-6.77-3.03-6.77-6.77s3.03-6.77,6.77-6.77h278.4c3.74,0,6.77,3.03,6.77,6.77s-3.03,6.77-6.77,6.77v-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m95.8,224.4h278.4c8.72,0,15.8-7.07,15.8-15.8s-7.07-15.8-15.8-15.8h-123.4v-84.23l42.16,42.16c6.16,6.18,16.16,6.2,22.34.05,6.18-6.16,6.2-16.16.05-22.34l-77.18-77.09c-1.76-1.72-4.56-1.72-6.32,0l-77.18,77c-6.16,6.18-6.14,16.19.05,22.34,6.18,6.16,16.19,6.14,22.34-.05h0l42.16-42.07v84.32h-123.4c-8.72,0-15.8,7.07-15.8,15.8s7.07,15.8,15.8,15.8v-.09Zm0-22.57h127.92c2.49,0,4.51-2.02,4.51-4.51v-99.3c0-1.82-1.11-3.46-2.8-4.15-1.67-.7-3.61-.31-4.87.99l-49.92,49.83c-2.74,2.55-7.02,2.4-9.57-.34-2.42-2.6-2.42-6.63,0-9.23l73.93-74.3,73.93,73.93c2.74,2.64,2.82,7.01.18,9.75-2.64,2.74-7.01,2.82-9.75.18h0l-49.92-50.28c-1.29-1.26-3.2-1.64-4.87-.99-1.69.69-2.79,2.33-2.8,4.15v99.3c0,2.49,2.02,4.51,4.51,4.51h127.92c3.74,0,6.77,3.03,6.77,6.77s-3.03,6.77-6.77,6.77H95.8c-3.74,0-6.77-3.03-6.77-6.77s3.03-6.77,6.77-6.77v.45Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrows);
export default __webpack_public_path__ + "static/media/expand-arrows.790b7b4b8acb51837b98dcd041b6e689.svg";
export { ForwardRef as ReactComponent };